<template>
  <div class="modal" @click.self="$emit('close')">
    <div class="modal-content">
      <span class="close-btn" @click="$emit('close')">&times;</span>
      <h2>{{ title }}</h2>
      <div v-html="content"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: {
    title: String,
    content: String
  }
}
</script>

<style>
.modal {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(5px);
}
.modal h2 {
  color: var(--primary-dark);
  margin-bottom: clamp(15px, 2vw, 20px);
  padding-bottom: 8px;
  border-bottom: 2px solid var(--medium-gray);
  font-size: clamp(1.3rem, 2.5vw, 1.5rem);
}

.modal p {
  margin-bottom: clamp(10px, 1.5vw, 15px);
  line-height: 1.6;
  font-size: clamp(0.9rem, 1.8vw, 1rem);
}

.modal strong {
  color: var(--primary-dark);
}

.modal-content {
  background-color: var(--white);
  padding: clamp(20px, 3vw, 30px);
  border-radius: var(--border-radius);
  width: min(90%, 800px);
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.2);
  animation: modalFadeIn 0.3s ease;
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.close-btn {
  position: absolute;
  top: clamp(10px, 1.5vw, 15px);
  right: clamp(15px, 2vw, 20px);
  font-size: clamp(1.5rem, 3vw, 1.8rem);
  cursor: pointer;
  color: var(--secondary-color);
  transition: var(--transition);
}

.close-btn:hover {
  color: var(--primary-color);
}


</style>